import { createPageSlice } from "./createPageSlice";

// Server-paginated slice for the "Client's Manager Mappings" (client-user mapping) Master Data grid.
// Sorted by id since the displayed user fields are enriched remotely and are not sortable server-side.
const clientMappingPageSlice = createPageSlice("clientMappingPage", {
    defaultSortBy: "id",
    defaultSortDirection: "ASC",
});

export const clientMappingPageActions = clientMappingPageSlice.actions;
export default clientMappingPageSlice;
